function InitReviews() {

    const root = document.querySelector('.bella-reviews');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    
    const bellaReviewDataNode = root.querySelector('[data-review-data]');
    const bellaReviewPayloadText = (bellaReviewDataNode?.content?.textContent || bellaReviewDataNode?.textContent || '').trim();
    let payload;
    try {
      payload = JSON.parse(bellaReviewPayloadText);
      if (typeof payload === 'string') payload = JSON.parse(payload);
    } catch (error) { return; }
    if (!payload || !Number(payload.number_of_reviews || 0)) return;
    
    // SEO 3: URL Parameters (History API) - Read from URL on initial load
    const params = new URLSearchParams(window.location.search);
    const initialPage = Number(params.get('review_page')) || (payload.pagination || {}).current_page || 1;
    const initialFilter = params.get('rating') || 'all';
    const initialSort = params.get('sort_by') || 'newest';

    const state = { reviews: payload.reviews || [], page: initialPage, filter: initialFilter, sort: initialSort };
    const $ = (selector, parent = root) => parent.querySelector(selector);
    
    const labels = {
      summaryBefore: root.dataset.summaryBefore || 'Based on',
      summaryAfter: root.dataset.summaryAfter || 'reviews',
      verifiedBuyer: root.dataset.verifiedBuyerLabel || 'Verified Buyer',
      customerReview: root.dataset.customerReviewLabel || 'Customer Review',
      reviewed: root.dataset.reviewedLabel || 'Reviewed'
    };
    
    const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, character => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#39;', '"':'&quot;' }[character]));
    let starClipId = 0;
    const starPath = 'm10 1.5 2.57 5.21 5.75.84-4.16 4.05.98 5.73L10 14.63l-5.14 2.7.98-5.73L1.68 7.55l5.75-.84L10 1.5Z';
    
    const stars = (rating) => Array.from({ length: 5 }, (_, index) => {
      const fill = Math.max(0, Math.min(100, (Number(rating) - index) * 100));
      const clipId = `bella-star-${starClipId++}`;
      return `<svg viewBox="0 0 20 20" aria-hidden="true"><defs><clipPath id="${clipId}"><rect x="0" y="0" width="${fill / 5}" height="20"/></clipPath></defs><path fill="#ded9d2" d="${starPath}"/><path fill="currentColor" clip-path="url(#${clipId})" d="${starPath}"/></svg>`;
    }).join('');
    
    const date = (value) => new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { day:'2-digit', month:'2-digit', year:'numeric' }).format(new Date(value));
    
    // SEO 1: Semantic HTML - Using <time datetime="..."> for dates instead of simple spans
    const reviewMeta = (review) => {
        const parts = [];
        if (review.reviewer_name) parts.push(`<span>${escapeHtml(review.reviewer_name)}</span>`);
        parts.push(`
            <span class="verified"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/></svg>
            ${escapeHtml(review.verified_buyer ? labels.verifiedBuyer : labels.customerReview)}</span>`
        );
        if (review.created_at) {
            parts.push(`<time datetime="${escapeHtml(review.created_at)}">${escapeHtml(labels.reviewed)} ${date(review.created_at)}</time>`);
        }
        return parts.join('');
    };

    const product = (review) => review.product_title ? `<a class="bella-reviews__product" href="${escapeHtml(review.product_url || '#')}">${review.product_variant_image_url ? `<img src="${escapeHtml(review.product_variant_image_url)}" alt="">` : ''}<span>${escapeHtml(review.product_title)}</span></a>` : '';
    
    // SEO 2: Dynamic Alt Tags - Adding product context to image alt attributes
    const renderReview = (review) => {
        let replyHtml = '';
        if (review.reply_content) {
            const replyName = escapeHtml(review.shop_reply_name || 'Store Owner');
            const repliedLabel = $('[data-review-list]').dataset.replied;
            replyHtml = `
            <div class="bella-reviews__reply">
                <p class="bella-reviews__reply-header">↪ ${replyName} ${repliedLabel}:</p>
                <div class="bella-reviews__reply-body">${review.reply_content}</div>
            </div>`;
        }

        return `<article class="bella-reviews__review">
            <h3 class="bella-reviews__review-title" ${review.title ? '' : 'hidden'}>${escapeHtml(review.title || '')}</h3>
            <p class="bella-reviews__body">${escapeHtml(review.body || '')}</p>
            <p class="bella-reviews__meta">${reviewMeta(review)}</p>
            <div class="bella-reviews__footer">
                <span class="bella-reviews__review-stars" aria-label="${escapeHtml(String(review.rating))} out of 5 stars">${stars(review.rating)}</span>
                ${product(review)}
            </div>
            ${(review.pictures_urls || []).length ? `<div class="bella-reviews__photos">${review.pictures_urls.map((picture, index) => `<button class="bella-reviews__photo" type="button" data-open-review="${escapeHtml(review.uuid)}" data-photo-index="${index}"><img src="${escapeHtml(picture.compact || picture.small || picture.original)}" alt="Customer review photo ${index + 1} of ${escapeHtml(review.product_title || 'product')}"></button>`).join('')}</div>` : ''}
            ${replyHtml}
        </article>`;
    };

    function visibleReviews() { 
        let reviews = state.reviews.filter(review => state.filter === 'all' || Number(review.rating) === Number(state.filter)); 
        return reviews.sort((a,b) => state.sort === 'oldest' ? new Date(a.created_at) - new Date(b.created_at) : state.sort === 'highest' ? Number(b.rating) - Number(a.rating) : state.sort === 'lowest' ? Number(a.rating) - Number(b.rating) : new Date(b.created_at) - new Date(a.created_at)); 
    }
    
    function renderReviews() { 
        if(state.reviews.length === 0) {
            $('[data-review-list]').innerHTML = '<p class="bella-reviews__body" style="padding: 20px 0;">No reviews match this filter.</p>';
        } else {
            $('[data-review-list]').innerHTML = state.reviews.map(renderReview).join(''); 
        }
    }
    
    function galleryItems() { 
        return (payload.photo_gallery || []).flatMap(review => (review.pictures_urls || []).map((picture, index) => ({ review, picture, index }))); 
    }
    
    function renderGallery() { 
        const items = galleryItems(), wrap = $('[data-gallery-wrap]'); 
        if (!items.length) return; 
        wrap.hidden = false; 
        const track = $('[data-gallery]'); 
        track.innerHTML = items.map(({review, picture, index}) => `<button class="bella-reviews__gallery-item" type="button" data-open-review="${escapeHtml(review.uuid)}" data-photo-index="${index}"><img src="${escapeHtml(picture.compact || picture.small || picture.original)}" alt="Customer photo by ${escapeHtml(review.reviewer_name || 'customer')}"></button>`).join(''); 
        const sync = () => { 
            const overflow = track.scrollWidth > track.clientWidth + 3; 
            $('[data-gallery-prev]').classList.toggle('is-active', overflow && track.scrollLeft > 2); 
            $('[data-gallery-next]').classList.toggle('is-active', overflow && track.scrollLeft + track.clientWidth < track.scrollWidth - 2); 
        }; 
        track.addEventListener('scroll', sync, {passive:true}); 
        $('[data-gallery-prev]').addEventListener('click', () => track.scrollBy({left:-180, behavior:'smooth'})); 
        $('[data-gallery-next]').addEventListener('click', () => track.scrollBy({left:180, behavior:'smooth'})); 
        requestAnimationFrame(sync); window.addEventListener('resize', sync); 
    }
    
    function renderPagination() { 
        const pagination = payload.pagination || {};
        const total = Number(pagination.total_pages || 1); 
        const nav = $('[data-pagination]'); 
        
        if (total < 2) {
            nav.innerHTML = '';
            return; 
        }
        const button = (page, label = page, current = false) => `<button class="bella-reviews__page" type="button" data-page="${page}" ${current ? 'aria-current="page"' : ''}>${label}</button>`; 
        nav.innerHTML = `${state.page > 1 ? button(state.page - 1, '‹') : ''}${Array.from({length: total}, (_, index) => button(index + 1, index + 1, index + 1 === state.page)).join('')}${state.page < total ? button(state.page + 1, '›') : ''}`; 
    }
    
    function openModal(review, imageIndex = 0) { 
        if (!review) return; 
        const pictures = review.pictures_urls || []; 
        const picture = pictures[imageIndex] || pictures[0]; 
        if (!picture) return; 
        const modal = $('[data-modal]'); 
        $('[data-modal-image]').src = picture.huge || picture.original || picture.small; 
        $('[data-modal-image]').alt = `Customer photo by ${review.reviewer_name || 'customer'}`; 
        $('[data-modal-title]').textContent = review.title || review.product_title || 'Customer review'; 
        $('[data-modal-stars]').innerHTML = stars(review.rating); 
        $('[data-modal-body]').textContent = review.body || ''; 
        $('[data-modal-meta]').innerHTML = reviewMeta(review); 
        $('[data-modal-thumbs]').innerHTML = pictures.map((item, index) => `<button type="button" data-modal-photo="${index}"><img src="${escapeHtml(item.compact || item.small || item.original)}" alt="Customer photo ${index + 1}"></button>`).join(''); 
        const answers = review.cf_answers || []; 
        $('[data-modal-answers]').innerHTML = answers.map(answer => `<span>${escapeHtml(answer.question || answer.question_title || '')}: <strong>${escapeHtml(answer.value || answer.answer || '')}</strong></span>`).join(''); 
        modal.dataset.reviewId = review.uuid; 
        if (!modal.open) modal.showModal(); 
    }

    function updateURL() {
        const url = new URL(window.location);
        state.page > 1 ? url.searchParams.set('review_page', state.page) : url.searchParams.delete('review_page');
        state.filter !== 'all' ? url.searchParams.set('rating', state.filter) : url.searchParams.delete('rating');
        state.sort !== 'newest' ? url.searchParams.set('sort_by', state.sort) : url.searchParams.delete('sort_by');
        window.history.replaceState({}, '', url);
    }

    async function fetchReviews() {
        root.classList.remove('is-loaded');

        const productId = root.dataset.productId;
        const shopDomain = root.dataset.shopDomain;
        const apiToken = root.dataset.apiToken;

        const sortMap = { 'newest': 'newest', 'oldest': 'oldest', 'highest': 'highest_rating', 'lowest': 'lowest_rating' };
        let url = `https://judge.me/api/v1/widgets/product_review.json?api_token=${apiToken}&shop_domain=${shopDomain}&product_id=${productId}&page=${state.page}`;

        if (state.filter !== 'all') url += `&rating=${state.filter}`;
        if (state.sort !== 'newest') url += `&sort_by=${sortMap[state.sort]}`;

        updateURL();

        try {
            const res = await fetch(url);
            if (res.ok) {
                const data = await res.json();
                state.reviews = data.reviews || [];
                payload.pagination = data.pagination || { total_pages: 1, current_page: 1 };
            } else {
                throw new Error('API request failed');
            }
        } catch (e) {
            console.warn('Judge.me API Error, falling back to local filter:', e);
            let localReviews = (payload.reviews || []).filter(r => state.filter === 'all' || Number(r.rating) === Number(state.filter));
            localReviews.sort((a,b) => state.sort === 'oldest' ? new Date(a.created_at) - new Date(b.created_at) : state.sort === 'highest' ? Number(b.rating) - Number(a.rating) : state.sort === 'lowest' ? Number(a.rating) - Number(b.rating) : new Date(b.created_at) - new Date(a.created_at));
            state.reviews = localReviews;
        }

        renderReviews();
        renderPagination();

        const headerOffset = 100;
        const elementPosition = root.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({ top: offsetPosition, behavior: "smooth" });

        setTimeout(() => { root.classList.add('is-loaded'); }, 300);
    }
    
    root.addEventListener('click', event => { 
        const opener = event.target.closest('[data-open-review]'); 
        if (opener) { 
            const review = state.reviews.find(item => item.uuid === opener.dataset.openReview) || (payload.photo_gallery || []).find(item => item.uuid === opener.dataset.openReview); 
            openModal(review, Number(opener.dataset.photoIndex || 0)); 
        } 
        
        const close = event.target.closest('[data-modal-close]'); 
        const backDrop = event.target.hasAttribute('open');
        if (close || backDrop) $('[data-modal]').close(); 
        
        const thumb = event.target.closest('[data-modal-photo]'); 
        if (thumb) { 
            const review = state.reviews.find(item => item.uuid === $('[data-modal]').dataset.reviewId) || (payload.photo_gallery || []).find(item => item.uuid === $('[data-modal]').dataset.reviewId); 
            openModal(review, Number(thumb.dataset.modalPhoto)); 
        } 
        
        const pageBtn = event.target.closest('[data-page]'); 
        if (pageBtn) { 
            event.preventDefault(); 
            const newPage = Number(pageBtn.dataset.page);
            if (newPage && newPage !== state.page) {
                state.page = newPage;
                fetchReviews();
            }
        } 
    });
    
    const filterSelect = $('[data-filter]');
    if (filterSelect) {
        filterSelect.value = state.filter;
        filterSelect.addEventListener('change', event => { 
            state.filter = event.target.value; 
            state.page = 1; 
            fetchReviews(); 
        }); 
    }

    const sortSelect = $('[data-sort]');
    if (sortSelect) {
        sortSelect.value = state.sort;
        sortSelect.addEventListener('change', event => { 
            state.sort = event.target.value; 
            state.page = 1; 
            fetchReviews(); 
        });
    }

    $('[data-average]').textContent = Number(payload.average_rating || 0).toFixed(2); 
    $('[data-stars]').innerHTML = stars(payload.average_rating); 
    $('[data-stars]').setAttribute('aria-label', `${payload.average_rating} out of 5 stars`); 
    $('[data-summary]').textContent = `${labels.summaryBefore} ${payload.number_of_reviews || 0} ${labels.summaryAfter}`.trim();
    
    // Check if URL forces an initial API fetch
    if (state.page !== 1 || state.filter !== 'all' || state.sort !== 'newest') {
        fetchReviews();
    } else {
        renderGallery(); 
        renderReviews(); 
        renderPagination();
        
        setTimeout(() => {
            root.classList.add('is-loaded');
        }, 400);
    }
  }
  document.addEventListener('DOMContentLoaded', InitReviews);